export const formatKeysToDisplay = (data: any) =>
  Object.keys(data).filter((k) => k !== 'website' && k !== 'logoUrl');
